import React from 'react';
import { MDBBtn, MDBCard, MDBCardBody, MDBCardGroup, MDBCardText, MDBCardTitle, MDBCol, MDBFooter, MDBInput, MDBLink, MDBRow, MDBTable } from 'mdbreact'
import axios from '../../authAxios';

export class BasicInfoCard extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            applicationDataObj: [],
            origin: '',
            nationality: '',
            travelling_to_country: '',
            total_applicants: '',
            arrival_dt: '',
            departure_dt: '',
            visa_type: '',
            entry_type: '',
            visa_duration: '',
            duration_type:'days',
            category: ""
        }
    }
    componentDidMount() {
        setTimeout(() => {
            this.api_getApplicationInfo()
            // console.log(this.props.applicantLength.length);
        }, 2000);
    }

    capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    api_getApplicationInfo = e => {
        //http://192.168.1.16:3000/visa/getApplicationApplicantsDetails
        // console.log("get application details api ....") 
        axios
            .post('/visa/getApplicationApplicantsDetails', {
                "application_id": localStorage.getItem('application_id')//"5fd74a00c55c50d75e7f6577",
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                // console.log(resp)
                if (resp.data.data === "error") {
                    if (resp.data.error_code === "1003") {
                        alert(resp.data.msg)
                    } else {
                        alert(resp.data.msg)
                    }
                } else {
                    // console.log("success")
                    // console.log(resp.data.dataobj)
                    localStorage.setItem(
                        "origin_country",
                        resp.data.dataobj.application.origin
                    );
                    this.setState({
                        applicationDataObj: resp.data.dataobj,
                        origin: resp.data.dataobj.application.origin,
                        nationality: resp.data.dataobj.application.nationality,
                        travelling_to_country: resp.data.dataobj.application.travelling_to_country,
                        total_applicants: resp.data.dataobj.application.total_applicants,
                        arrival_dt: resp.data.dataobj.application.journey_start_date,
                        departure_dt: resp.data.dataobj.application.journey_end_date,
                        visa_type: resp.data.dataobj.application.visa_processing_type,
                        entry_type: resp.data.dataobj.application.visa_entry_type,
                        visa_duration: resp.data.dataobj.application.total_days,
                        category: resp.data.dataobj.application.visa_category
                    })
                    var visa_duration_type = resp.data.dataobj.application.duration_type
                     if (visa_duration_type !=null || visa_duration_type !=undefined ){
                            this.setState({duration_type:visa_duration_type
                        })
                     }

                }

            })

    }
    render() {
        var arrivalDtObj = new Date(this.state.arrival_dt)
        var departureDtObj = new Date(this.state.departure_dt)
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"];

        var arrivalDateStr = arrivalDtObj.getDate() + '-' + monthNames[(arrivalDtObj.getMonth())] + '-' + arrivalDtObj.getFullYear()
        var depatureDateStr = departureDtObj.getDate() + '-' + monthNames[(departureDtObj.getMonth())] + '-' + departureDtObj.getFullYear()

        return (
            <>
                <MDBCard style={{ marginTop: 20 }}>
                    <MDBCardBody>
                        <MDBCardTitle>Basic Information</MDBCardTitle>
                        <hr />
                        <MDBCardText>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <p style={{ color: 'grey' }}>Country of Residence(COR): <span style={{ color: 'black' }}> {this.state.origin}</span></p>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <p style={{ color: 'grey' }}>Travelling to: <span style={{ color: 'black' }}> {this.state.travelling_to_country}</span></p>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <p style={{ color: 'grey' }}>Visa Type: <span style={{ color: 'black' }}> {this.state.visa_type} | {this.state.entry_type} Entry</span></p>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <p style={{ color: 'grey' }}>Visa Duration: <span style={{ color: 'black' }}> {this.state.visa_duration} {this.capitalize(this.state.duration_type)}</span></p>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <p style={{ color: 'grey' }}>Nationality: <span style={{ color: 'black' }}> {this.state.nationality}</span></p>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <p style={{ color: 'grey' }}>Category: <span style={{ color: 'black' }}> {this.capitalize(this.state.category)} </span></p>
                                </MDBCol>
                                <MDBCol size="12" lg="2">
                                    <p style={{ color: 'grey' }}>Applicants: <span style={{ color: 'black' }}> {(this.props.applicantLength === undefined ? this.state.total_applicants : this.props.applicantLength.length)}</span></p>
                                </MDBCol>
                                <MDBCol size="12" lg="4">
                                    <p style={{ color: 'grey' }}>Travel Dates: <span style={{ color: 'black' }}> {arrivalDateStr} To {depatureDateStr}</span></p>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardText>
                    </MDBCardBody>
                </MDBCard>

            </>
        );
    }
}

export default BasicInfoCard;